<template>
    <div class="h100 flex">
        <div class="flex-column h100" style="width: 250px;">
            <div class="flex items-center pl20">
                <el-input
                    @input="remoteMethod"
                    size="medium" class="flex-width"
                    placeholder=""
                    prefix-icon="el-icon-search"
                    v-model="searchText">
                </el-input>
            </div>
            <div class="scroll mt10" style="max-height: calc(100%-28px);">
                <div class="m-api-item" style="height: 50px;" v-for="(item, i) in apps" :key="i" @click="selectApp(item)">
                    <img :src="item.icon" alt="" style="width: 40px; height: 40px;">
                    <div class="ml10 fs12">
                        <div class="flex fs13 bold">{{item.name}}</div>
                        <div class="flex" style="font-size: 10px;">{{ item.package_name }}</div>
                    </div>
                </div>
            </div>
            <div class="mt10" style="flex: 1; max-height: calc(100%-88px); overflow: auto;">
                <div class="">
                    <div class="m-version-item flex fs12 items-center mb5 cursor-pointer" v-for="(item, i) in versions" :key="i" @click="selectVersion=item.version_code,onChangeAppVersion(item.version_code)" :class="item.version_code == selectVersion ? `m-is-select ${item.is_set ? 'm-is-set' : 'm-is-notset'}` : `m-is-notselect ${item.is_set ? 'm-is-set' : 'm-is-notset'}`">
                        <div class="flex-width pl20 pr20 m-select-version fs12">
                            <div class="flex items-center">
                                <span class="flex-1 flex">版本号: {{ item.version_code }}</span>
                                <span class="fs8" v-if="item.is_set">已设置</span>
                                <span class="fs8" v-else>未设置</span>

                                <span class="fs8 ml5" v-if="item.on">开</span>
                                <span class="fs8 ml5" v-else>关</span>
                                
                            </div>
                            <div class="flex">版本名: {{ item.version_name }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-width ml25 h100 pb20 scroll">
            <div class="m-panel">
                <div class="flex fs14 items-center" style="color: #636578; font-weight: 600">
                    <div class="flex-1 flex">广告设置</div>
                    <div class="mr10 fs12 cursor-pointer flex items-center" @click="copyClickUrl" v-if="channel == 'vivo'">
                        点击监测
                    </div>
                    <div class="mr10 fs12 cursor-pointer flex items-center" @click="showModifyHistory">
                        修改记录
                    </div>
                    <el-button :loading="saveLoading" type="primary" size="small" style="background-color: #676cf6;" @click="save">保存</el-button>
                </div>
                <div class="flex fs12 items-center mt25">
                    <div class="flex-1 flex items-center">
                        <el-switch
                            v-model="currentVersionConfig.on"
                            active-color="#676cf6"
                            inactive-color="#ff4949">
                        </el-switch>
                        <div class="ml10">广告开关</div>
                    </div>
                    <div v-if="channel == 'hz'" class="flex-1 flex items-center">
                        <el-switch
                            v-model="currentVersionConfig.non_ru_on"
                            active-color="#676cf6"
                            inactive-color="#ff4949">
                        </el-switch>
                        <div class="ml10">非俄罗斯开关</div>
                    </div>

                    <div class="flex-1 flex items-center" v-if="channel != 'vivo'">
                        <el-switch
                            @change="onChangeMode"
                            v-model="currentVersionConfig.interval_click_mode"
                            active-color="#676cf6"
                            inactive-color="#ff4949">
                        </el-switch>
                        <div class="ml10">UI弹开关</div>
                    </div>

                    <div class="flex-1 flex items-center" v-if="channel != 'vivo'">
                        <el-switch
                            @change="onChangeMode"
                            v-model="currentVersionConfig.interval_ad_mode_switch"
                            active-color="#676cf6"
                            inactive-color="#ff4949">
                        </el-switch>
                        <div class="ml10">广告轮询模式</div>
                    </div>

                    <div class="flex-1 flex items-center" v-if="channel != 'vivo'">
                        <div class="flex mt3">
                            <el-switch
                            v-model="currentVersionConfig.test_mode"
                            active-color="#676cf6"
                            inactive-color="#ff4949">
                            </el-switch>
                        </div>
                        <div class="ml10" v-if="channel == 'xm'">日志开关</div>
                        <div class="ml10" v-else>GP测试模式</div>
                    </div>

                </div>
                <div class="mt20 flex">
                    <div class="flex-1">
                        <div class="items-center" v-if="channel != 'vivo'">
                            <div class="fs12 flex" style="color: #828392;">
                                <label for="id-banner">横幅刷新间隔(秒)</label>
                            </div>
                            <div class="flex mt5">
                                <el-input id="id-banner" v-model="currentVersionConfig.interval4_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" style="color: #828392;" v-if="channel != 'vivo'">
                            <div class="fs12 flex">UI弹间隔(秒)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval5_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <!-- <div class="items-center" style="color: #828392;" v-if="channel == 'vivo'">
                            <div class="fs12 flex">悬浮原生刷新间隔(秒)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval5_sec" size="medium"></el-input>
                            </div>
                        </div> -->

                        <div class="items-center" style="color: #828392;" v-if="channel == 'vivo'">
                            <div class="fs12 flex">一次性加载原生数量</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.float_native_count" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" style="color: #828392;" v-if="channel == 'vivo'">
                            <div class="fs12 flex">优量汇一次性加载原生数量</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.float_native_width" size="medium"></el-input>
                            </div>
                        </div>
                
                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex items-center" style="color: #828392;">
                                UI弹广告顺序<span v-if="channel == 'hz' || channel == 'vivo'">(买量)</span>
                                <div class="flex ml10 items-center">
                                    <el-link type="primary" @click="selectAd(0)" style="font-size: 12px;">原生</el-link>
                                    <el-link type="primary" class="ml10" @click="selectAd(1)" style="font-size: 12px;">插屏</el-link>
                                    <el-link type="primary" class="ml10" @click="selectAd(2)" style="font-size: 12px;">激励</el-link>
                                </div>
                            </div>
                            <div class="flex mt5">
                                <div class="br5 flex items-center pl5" style="border: 1px solid rgba(0,0,0,0.1); height: 34px; width: 100%;">
                                    <el-tag
                                        class="mr5"
                                        v-for="(tag, i) in currentVersionConfig.interval_ad_sequences" :key="i"
                                        closable
                                        @close="removeAdSeq(tag)"
                                        type="success">
                                        {{tag.name}}
                                    </el-tag>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="items-center mt15" style="color: #828392;" v-if="channel == 'vivo'">
                            <div class="fs12 flex">原生弹间隔(秒)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval5_sec" size="medium"></el-input>
                            </div>
                        </div> -->

                        <!-- <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex items-center" style="color: #828392;">
                                原生误点击顺序
                                <div class="flex ml10 items-center">
                                    <el-link type="primary" @click="selectAd(1)" style="font-size: 12px;">误点</el-link>
                                    <el-link type="primary" class="ml10" @click="selectAd(0)" style="font-size: 12px;">不误点</el-link>
                                </div>
                            </div>
                            <div class="flex mt5">
                                <div class="br5 pl5" style="border: 1px solid rgba(0,0,0,0.1); width: 100%; float: left; overflow: hidden;">
                                    <el-tag
                                        class="mr5"
                                        v-for="(tag, i) in currentVersionConfig.interval_ad_sequences" :key="i"
                                        closable
                                        @close="removeAdSeq(tag)"
                                        type="success">
                                        <span v-if="tag.tag == 0">不误点</span>
                                        <span v-else-if="tag.tag == 1">误点</span>
                                    </el-tag>
                                </div>
                            </div>
                        </div> -->

                        <div class="items-center mt15" v-if="channel == 'hz'">
                            <div class="fs12 flex items-center" style="color: #828392;">
                                UI弹广告顺序(自然)
                                <div class="flex ml10 items-center">
                                    <el-link type="primary" @click="selectAd2(0)" style="font-size: 12px;">原生</el-link>
                                    <el-link type="primary" class="ml10" @click="selectAd2(1)" style="font-size: 12px;">插屏</el-link>
                                    <el-link type="primary" class="ml10" @click="selectAd2(2)" style="font-size: 12px;">激励</el-link>
                                </div>
                            </div>
                            <div class="flex mt5">
                                <div class="br5 flex items-center pl5" style="border: 1px solid rgba(0,0,0,0.1); height: 34px; width: 100%;">
                                    <el-tag
                                        class="mr5"
                                        v-for="(tag, i) in currentVersionConfig.interval_free_ad_sequences" :key="i"
                                        closable
                                        @close="removeAdSeq2(tag)"
                                        type="success">
                                        {{tag.name}}
                                    </el-tag>
                                </div>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">游戏链接(买量)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.game_url_1" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">游戏链接(自然)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.game_url_2" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex">
                                <div class="flex-width flex items-center" style="color: #828392;">定时器1</div>
                            </div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval1_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex">
                                <div class="flex-width flex items-center" style="color: #828392;">华为/传音 强弹原生(秒)</div>
                            </div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval1_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex">
                                <div class="flex-width flex items-center" style="color: #828392;">华为/传音 强弹插屏(秒)</div>
                            </div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval6_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex" style="color: #828392;">华为/传音 强弹激励(秒)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval7_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex" style="color: #828392;">华为原生误点击率(%)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.native_click_rate" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'hz'">
                            <div class="fs12 flex" style="color: #828392;">YANDEX原生误点击率(%)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.other_native_click_rate" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex" style="color: #828392;">YANDEX横幅误点击率(%)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.banner_click_rate" size="medium"></el-input>
                            </div>
                        </div>

                    </div>
                    <div class="ml20 flex-1" >
                        <!-- <div v-if="channel == 'vivo'">
                            <div>
                                <div class="fs12 flex m-panel-subtitle">悬浮原生(左1)</div>
                                <div class="flex mt10 items-center">
                                    <span class="m-panel-subtitle fs12">开关</span>
                                    <el-switch class="ml5"
                                        v-model="nativeLayout.o0"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                    <span class="ml10 m-panel-subtitle fs12">透明</span>
                                    <el-switch class="ml5"
                                        v-model="nativeLayout.a0"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                    <span class="ml10 m-panel-subtitle fs12">坐标</span>
                                    <div class="flex ml10">
                                        <el-input v-model="nativeLayout.p0" size="medium"></el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="mt15">
                                <div class="fs12 flex m-panel-subtitle">悬浮原生(左2)</div>
                                <div class="flex mt10 items-center">
                                    <span class="m-panel-subtitle fs12">开关</span>
                                    <el-switch class="ml5"
                                        v-model="nativeLayout.o1"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                    <span class="ml10 m-panel-subtitle fs12">透明</span>
                                    <el-switch class="ml5"
                                        v-model="nativeLayout.a1"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                    <span class="ml10 m-panel-subtitle fs12">坐标</span>
                                    <div class="flex ml10">
                                        <el-input v-model="nativeLayout.p1" size="medium"></el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="mt15">
                                <div class="fs12 flex m-panel-subtitle">悬浮原生(右1)</div>
                                <div class="flex mt10 items-center">
                                    <span class="m-panel-subtitle fs12">开关</span>
                                    <el-switch class="ml5"
                                        v-model="nativeLayout.o2"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                    <span class="ml10 m-panel-subtitle fs12">透明</span>
                                    <el-switch class="ml5"
                                        v-model="nativeLayout.a2"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                    <span class="ml10 m-panel-subtitle fs12">坐标</span>
                                    <div class="flex ml10">
                                        <el-input v-model="nativeLayout.p2" size="medium"></el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="mt15">
                                <div class="fs12 flex m-panel-subtitle">悬浮原生(右2)</div>
                                <div class="flex mt10 items-center">
                                    <span class="m-panel-subtitle fs12">开关</span>
                                    <el-switch class="ml5"
                                        v-model="nativeLayout.o3"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                    <span class="ml10 m-panel-subtitle fs12">透明</span>
                                    <el-switch class="ml5"
                                        v-model="nativeLayout.a3"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                    <span class="ml10 m-panel-subtitle fs12">坐标</span>
                                    <div class="flex ml10">
                                        <el-input v-model="nativeLayout.p3" size="medium"></el-input>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="items-center" v-if="channel != 'vivo'">
                            <div class="fs12 flex" style="color: #828392;">横幅位置</div>
                            <div class="flex mt5">
                                <el-select class="w100"v-model="default_version_config.banner_pos" placeholder="请选择" size="medium">
                                    <el-option
                                        v-for="item in bannerPositions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="items-center mt15" v-if="channel == 'fz'">
                            <div class="fs12 flex">
                                <div class="flex-width flex items-center" style="color: #828392;">华为topon包_原生(秒)</div>
                            </div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval1_sec" size="medium"></el-input>
                            </div>
                        </div>
                
                        <div class="items-center mt15" v-if="channel == 'fz'">
                            <div class="fs12 flex" style="color: #828392;">华为topon包_插屏(秒)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval2_sec" size="medium"></el-input>
                            </div>
                        </div>
                
                        <div class="items-center mt15" v-if="channel == 'fz'">
                            <div class="fs12 flex" style="color: #828392;">华为topon包_激励(秒)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval3_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">开屏间隔(秒)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.interval9_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15 flex" v-if="channel == 'hz' || channel == 'xm'">
                            <div class="flex-width">
                                <div class="fs12 flex m-panel-subtitle">广告最小展示间隔(秒)</div>
                                <div class="flex mt5">
                                    <el-input v-model="currentVersionConfig.ad_min_sec" size="medium"></el-input>
                                </div>
                            </div>
                            <div class="flex-width ml10">
                                <div class="fs12 flex m-panel-subtitle">广告最小展示间隔误差(百分比%)</div>
                                <div class="flex mt5">
                                    <el-input v-model="currentVersionConfig.ad_min_interval_offset" size="medium"></el-input>
                                </div>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'xm'">
                            <div class="fs12 flex m-panel-subtitle">原生自动关闭</div>
                            <div class="flex mt5 items-center" style="height: 36px;">
                                <el-switch
                                    v-model="currentVersionConfig.app_switch_2"
                                    active-color="#676cf6"
                                    inactive-color="#ff4949">
                                </el-switch>
                                <el-input v-if="currentVersionConfig.app_switch_2" class="flex-width ml20" v-model="currentVersionConfig.float_native_clost_sec" size="medium"></el-input>
                                <div v-if="currentVersionConfig.app_switch_2" class="fs12 ml20">秒后自动关闭</div>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'hz' || channel == 'xm'">
                            <div class="fs12 flex m-panel-subtitle">激励前置静默时间(秒)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.ad_delay_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'hz' || channel == 'xm'">
                            <div class="fs12 flex m-panel-subtitle">激励静默间隔(秒)</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.silent_sec" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'hz' || channel == 'xm'">
                            <div class="fs12 flex m-panel-subtitle">激励关闭后计时</div>
                            <div class="flex mt5 items-center" style="height: 36px;">
                                <el-switch
                                    v-model="currentVersionConfig.tick_after_close"
                                    active-color="#676cf6"
                                    inactive-color="#ff4949">
                                </el-switch>
                                <!-- <el-input v-model="currentVersionConfig.reward_request_count" size="medium"></el-input> -->
                            </div>
                        </div>

                        <!-- <div class="items-center mt15 flex" v-if="channel == 'hz' || channel == 'xm'">
                            <div>
                                <div class="fs12 flex m-panel-subtitle">yandex开关</div>
                                <div class="flex">
                                    <el-switch class="mt10"
                                        v-model="currentVersionConfig.app_switch_1"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                </div>
                            </div>
                        </div> -->

                        <div class="items-center mt15" v-if="channel == 'hz'">
                            <div class="fs12 flex" style="color: #828392;">横幅样式</div>
                            <div class="flex mt5">
                                <el-select class="w100"v-model="currentVersionConfig.banner_mode" placeholder="请选择" size="medium">
                                    <el-option key="0" label="huawei横幅" :value="0"></el-option>
                                    <el-option key="1" label="topon横幅" :value="1"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="items-center mt15 flex" v-if="channel == 'hz'">
                            <div>
                                <div class="fs12 flex m-panel-subtitle">拦截跳出链接</div>
                                <div class="flex mt5 items-center" style="height: 36px;">
                                    <el-switch
                                        v-model="currentVersionConfig.app_switch_1"
                                        active-color="#4480e9"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                </div>
                            </div>
                            <div class="ml30">
                                <div class="fs12 flex m-panel-subtitle">显示弹窗Webview</div>
                                <div class="flex mt5 items-center" style="height: 36px;">
                                    <el-switch
                                        v-model="currentVersionConfig.app_switch_2"
                                        active-color="#4480e9"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                </div>
                            </div>
                            
                        </div>

                        
                        <div class="items-center " v-if="channel == 'vivo'">
                            <div class="fs12 flex" style="color: #828392;">第几回合后自动点</div>
                            <div class="flex mt5">
                                <el-input v-model="currentVersionConfig.ad_min_interval_offset" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15 flex" v-if="channel == 'vivo'">
                            <div>
                                <div class="fs12 flex m-panel-subtitle">优量汇自动点击</div>
                                <div class="flex">
                                    <el-switch class="mt10"
                                        v-model="currentVersionConfig.app_switch_1"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="items-center mt10" v-if="channel == 'vivo'">
                            <div class="fs12 flex">百度击率(%)</div>
                            <div class="flex mt3">
                                <el-input v-model="currentVersionConfig.float_native_click_rate" size="small" style="width: 240px;"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15 flex" v-if="channel == 'vivo'">
                            <div>
                                <div class="fs12 flex m-panel-subtitle">百度自动点击</div>
                                <div class="flex">
                                    <el-switch class="mt10"
                                        v-model="currentVersionConfig.app_switch_2"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <div class="items-center mt15 flex" v-if="channel == 'vivo'">
                            <el-switch
                                @change="onChangeMode"
                                v-model="currentVersionConfig.interval_click_mode"
                                active-color="#676cf6"
                                inactive-color="#ff4949">
                            </el-switch>
                            <div class="ml10 fs12 flex m-panel-subtitle">开启广告透明</div>
                        </div>

                        <div class="items-center mt15 flex" v-if="channel == 'vivo'">
                            <el-switch
                                @change="onChangeMode"
                                v-model="currentVersionConfig.tick_after_close"
                                active-color="#676cf6"
                                inactive-color="#ff4949">
                            </el-switch>
                            <div class="ml10 fs12 flex m-panel-subtitle">开启虚拟菜单</div>
                        </div>

                        


                        <!-- <div class="items-center mt15 flex" v-if="channel == 'vivo'">
                            <div>
                                <div class="fs12 flex m-panel-subtitle">屏蔽退出</div>
                                <el-switch class="mt10"
                                    v-model="currentVersionConfig.app_switch_2"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949">
                                </el-switch>
                            </div>
                        </div>

                        <div class="items-center mt15 flex" v-if="channel == 'vivo'">
                            <div>
                                <div class="fs12 flex m-panel-subtitle">自动点击</div>
                                <el-switch class="mt10"
                                    v-model="currentVersionConfig.switch1"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949">
                                </el-switch>
                            </div>
                        </div> -->

                        <div class="items-center mt15 flex" v-if="channel == 'fz'">
                            <div>
                                <div class="fs12 flex m-panel-subtitle">预留开关1</div>
                                <el-switch class="mt10"
                                    v-model="currentVersionConfig.app_switch_1"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949">
                                </el-switch>
                            </div>
                            <div class="ml30">
                                <div class="fs12 flex m-panel-subtitle">预留开关2</div>

                                <el-switch class="mt10"
                                    v-model="currentVersionConfig.app_switch_2"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949">
                                </el-switch>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'hz'">
                            <div class="fs12 flex" style="color: #828392;">插屏样式</div>
                            <div class="flex mt5">
                                <div class="flex items-center">
                                    <div class="fs12 a50" style="width: 40px;">俄</div>
                                    <el-select class="w100"v-model="currentVersionConfig.inter_mode" placeholder="请选择" size="medium">
                                        <el-option key="0" label="华为插屏" :value="0"></el-option>
                                        <el-option key="1" label="TopOn插屏" :value="1"></el-option>
                                    </el-select>
                                </div>

                                <div class="flex items-center ml10">
                                    <div class="fs12 a50" style="width: 40px;">其他</div>
                                    <el-select class="w100"v-model="currentVersionConfig.inter_mode_non_ru" placeholder="请选择" size="medium">
                                        <el-option key="0" label="华为插屏" :value="0"></el-option>
                                        <el-option key="1" label="TopOn插屏" :value="1"></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt20" v-if="channel != 'vivo'">
                    <div class="flex">
                        <div class="flex-1">
                            <div class="items-center mb15" v-if="channel != 'xm'">
                                <div class="fs12 flex m-panel-subtitle">小原生间隔(秒)</div>
                                <div class="flex mt5">
                                    <el-input v-model="currentVersionConfig.interval8_sec" size="medium"></el-input>
                                </div>
                            </div>

                            <div class="items-center">
                                <div class="fs12 flex m-panel-subtitle">小原生宽</div>
                                <div class="flex mt5">
                                    <el-input v-model="currentVersionConfig.float_native_width" size="medium"></el-input>
                                </div>
                            </div>

                            <div class="items-center mt10" v-if="channel == 'hz' || channel == 'xm'">
                                <div class="fs12 flex">小原生点击率(%)</div>
                                <div class="flex mt3">
                                    <el-input v-model="currentVersionConfig.float_native_click_rate" size="small" style="width: 240px;"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1 ml20">
                            <div class="items-center">
                                <div class="fs12 flex m-panel-subtitle">小原生数量</div>
                                <div class="flex mt5">
                                    <el-input v-model="currentVersionConfig.float_native_count" size="medium"></el-input>
                                </div>
                            </div>

                            <!-- <div class="items-center mt15">
                                <div class="fs12 flex m-panel-subtitle">
                                    <span>小原生布局</span>
                                </div>
                                <div class="flex mt5">
                                    <el-select style="width: 240px;" v-model="nativeLayout.layout" placeholder="请选择" size="small">
                                    <el-option
                                        v-for="item in nativePositions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                    </el-select>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    
                    <div class="items-center mt15">
                        <div class="fs12 flex m-panel-subtitle">
                            <span>小原生1外边距</span>
                        </div>
                        <div class="flex mt5 fs12 items-center">
                            <span>小原生1布局</span>
                            <el-select class="ml10" style="width: 120px;" v-model="nativeLayout.layout" placeholder="请选择" size="small">
                                <el-option
                                    v-for="item in nativePositions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span class="ml10">左</span>
                            <el-input v-model="nativeLayout.margin0" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">上</span>
                            <el-input v-model="nativeLayout.margin1" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">右</span>
                            <el-input v-model="nativeLayout.margin2" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">下</span>
                            <el-input v-model="nativeLayout.margin3" size="small" class="flex-width ml10"></el-input>
                        </div>
                    </div>

                    <div class="items-center mt15">
                        <div class="fs12 flex m-panel-subtitle">
                            <span>小原生2外边距</span>
                        </div>
                        <div class="flex mt5 fs12 items-center">
                            <span>小原生2布局</span>
                            <el-select class="ml10" style="width: 120px;" v-model="nativeLayout.layout2" placeholder="请选择" size="small">
                                <el-option
                                    v-for="item in nativePositions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span class="ml10">左</span>
                            <el-input v-model="nativeLayout.margin20" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">上</span>
                            <el-input v-model="nativeLayout.margin21" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">右</span>
                            <el-input v-model="nativeLayout.margin22" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">下</span>
                            <el-input v-model="nativeLayout.margin23" size="small" class="flex-width ml10"></el-input>
                        </div>
                    </div>

                    <div class="items-center mt15">
                        <div class="fs12 flex m-panel-subtitle">
                            <span>小原生3外边距</span>
                        </div>
                        <div class="flex mt5 fs12 items-center">
                            <span>小原生3布局</span>
                            <el-select class="ml10" style="width: 120px;" v-model="nativeLayout.layout3" placeholder="请选择" size="small">
                                <el-option
                                    v-for="item in nativePositions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span class="ml10">左</span>
                            <el-input v-model="nativeLayout.margin30" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">上</span>
                            <el-input v-model="nativeLayout.margin31" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">右</span>
                            <el-input v-model="nativeLayout.margin32" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">下</span>
                            <el-input v-model="nativeLayout.margin33" size="small" class="flex-width ml10"></el-input>
                        </div>
                    </div>

                    <div class="items-center mt15">
                        <div class="fs12 flex m-panel-subtitle">
                            <span>小原生4外边距</span>
                        </div>
                        <div class="flex mt5 fs12 items-center">
                            <span>小原生4布局</span>
                            <el-select class="ml10" style="width: 120px;" v-model="nativeLayout.layout4" placeholder="请选择" size="small">
                                <el-option
                                    v-for="item in nativePositions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span class="ml10">左</span>
                            <el-input v-model="nativeLayout.margin40" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">上</span>
                            <el-input v-model="nativeLayout.margin41" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">右</span>
                            <el-input v-model="nativeLayout.margin42" size="small" class="flex-width ml10"></el-input>
                            <span class="ml10">下</span>
                            <el-input v-model="nativeLayout.margin43" size="small" class="flex-width ml10"></el-input>
                        </div>
                    </div>
                    
                </div>

            </div>


            <div class="m-panel mt20"  v-if="channel != 'xm'">
                <div class="flex fs14 items-center" style="color: #636578; font-weight: 600">
                    <div class="flex-1 flex">广告ID</div>
                </div>
                <div class="mt20 flex">
                    <div class="flex-1">
                        <div class="items-center mb15" v-if="channel == 'fz'">
                            <div class="fs12 flex m-panel-subtitle">大原生ID</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.native_1" @change="onChangeAdid('native_1', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mb15" v-if="channel != 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">开屏ID</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.splash" @change="onChangeAdid('splash', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center">
                            <div class="fs12 flex m-panel-subtitle">原生ID</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.native" @change="onChangeAdid('native', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">原生ID 2</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.native_1" @change="onChangeAdid('native_1', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">原生ID 3</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.native_2" @change="onChangeAdid('native_2', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">原生ID 4</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.native_3" @change="onChangeAdid('native_3', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">原生ID 5</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.native_4" @change="onChangeAdid('native_4', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">插屏</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.interstitial" @change="onChangeAdid('interstitial', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">百度APID</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.baidu_apid" @change="onChangeAdid('baidu_apid', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">百度APPID</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.baidu_appid" @change="onChangeAdid('baidu_appid', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">插屏视频</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.interstitial_2" @change="onChangeAdid('interstitial_2', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        
                        <div class="items-center mt15" v-if="channel == 'fz'">
                            <div class="fs12 flex m-panel-subtitle">热启动插屏</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.interstitial_3" @change="onChangeAdid('interstitial_3', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15" v-if="channel == 'xm'">
                            <div class="fs12 flex m-panel-subtitle">小米APPID</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.mi_app_id" @change="onChangeAdid('mi_app_id', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        
                    </div>
                    <div class="ml20 flex-1">
                        <div class="items-center">
                            <div class="fs12 flex m-panel-subtitle">激励</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.reward_0" @change="onChangeAdid('reward_0', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">激励(二)</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.reward_1" @change="onChangeAdid('reward_1', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">横幅</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.banner" @change="onChangeAdid('banner', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'fz' || channel == 'xm'">
                            <div class="fs12 flex m-panel-subtitle">原生横幅</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.banner_native" @change="onChangeAdid('banner_native', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel != 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">友盟</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.umkey" @change="onChangeAdid('umkey', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        
                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">优量汇ID</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.ylh_app_id" @change="onChangeAdid('ylh_app_id', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">优量汇原生1</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.ylh_native_0" @change="onChangeAdid('ylh_native_0', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">优量汇原生2</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.ylh_native_1" @change="onChangeAdid('ylh_native_1', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">优量汇原生3</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.ylh_native_2" @change="onChangeAdid('ylh_native_2', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">优量汇原生4</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.ylh_native_3" @change="onChangeAdid('ylh_native_3', $event)" size="medium"></el-input>
                            </div>
                        </div>

                        <div class="items-center mt15" v-if="channel == 'vivo'">
                            <div class="fs12 flex m-panel-subtitle">优量汇原生5</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.ylh_native_4" @change="onChangeAdid('ylh_native_4', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15" v-if="channel == 'xm'">
                            <div class="fs12 flex m-panel-subtitle">小米APPSECRET</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.mi_app_secret" @change="onChangeAdid('mi_app_secret', $event)" size="medium"></el-input>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="m-panel mt20" v-if="channel == 'xm'">
                <div class="flex fs14 items-center" style="color: #636578; font-weight: 600">
                    <div class="flex-1 flex">广告ID</div>
                </div>
                <div class="mt20 flex">
                    <div class="flex-1">
                        <div class="items-center">
                            <div class="fs12 flex m-panel-subtitle">小米APPID</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.mi_app_id" @change="onChangeAdid('mi_app_id', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">友盟</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.umkey" @change="onChangeAdid('umkey', $event)" size="medium"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 ml20">
                        <div class="items-center">
                            <div class="fs12 flex m-panel-subtitle">小米APPSECRET</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.mi_app_secret" @change="onChangeAdid('mi_app_secret', $event)" size="medium"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="mt20">
                    <div class="flex">
                        <i class="el-icon-circle-plus-outline" @click="addAdUnit"></i>
                        <el-dialog
                            title="提示"
                            :visible.sync="dialogAdIdVisible"
                            width="30%">
                            <div class="w100">
                                <el-form ref="form" :model="adUnitForm" label-width="80px">
                                    <el-form-item label="广告类型">
                                        <el-select v-model="adUnitForm.type" placeholder="请选择" size="medium" class="w100">
                                            <el-option
                                                v-for="item in adUnitTypes"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="广告ID">
                                        <el-input v-model="adUnitForm.adId" size="medium"></el-input>
                                    </el-form-item>
                                    <el-form-item label="底价">
                                        <el-input v-model="adUnitForm.price" size="medium"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <span slot="footer" class="dialog-footer">
                                <el-button @click="dialogAdIdVisible = false">取 消</el-button>
                                <el-button type="primary" @click="saveAdUnit">确 定</el-button>
                            </span>
                        </el-dialog>
                    </div>
                    <div>
                        <el-table :data="miAdUnits" style="width: 100%" size="mini">
                            <el-table-column prop="type_name" label="广告类型"></el-table-column>
                            <el-table-column prop="adId" label="广告ID"></el-table-column>
                            <el-table-column prop="price" label="底价"></el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="editAdUnit(scope.row)">编辑</el-button>
                                    <el-button type="text" @click="deleteAdUnit(scope.row)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div> -->
            </div>

            <div class="m-panel mt20" v-if="channel == 'vivo'">
                <div class="flex fs14 items-center" style="color: #636578; font-weight: 600">
                    <div class="flex mr10">广告源ID</div>
                    <i class="el-icon-circle-plus-outline cursor-pointer" @click="showAddSrcId"></i>
                </div>
                <div class="mt20">
                    <el-table :data="srcIdData" style="width: 100%">
                        <el-table-column prop="adv_id" label="户ID"></el-table-column>
                        <el-table-column prop="src_id" label="广告源ID"></el-table-column>
                    </el-table>
                </div>
            </div>

            <!-- yandex -->
            <div class="m-panel mt20" v-if="channel == 'xm' || channel == 'hz'">
                <div class="flex fs14 items-center" style="color: #636578; font-weight: 600">
                    <div class="flex-1 flex">Yandex ID</div>
                </div>
                <div class="mt20 flex">
                    <div class="flex-1">
                        <div class="items-center">
                            <div class="fs12 flex m-panel-subtitle">Yandex 开屏</div>
                            <div class="flex mt5">
                                <el-input v-model="yandex_config.appopen_id" size="medium" @change="onChangeYandexConfig"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">Yandex 激励</div>
                            <div class="flex mt5">
                                <el-input v-model="yandex_config.reward_id" size="medium" @change="onChangeYandexConfig"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">Yandex 插屏</div>
                            <div class="flex mt5">
                                <el-input v-model="yandex_config.inter_id" size="medium" @change="onChangeYandexConfig"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 ml20">
                        <div class="items-center">
                            <div class="fs12 flex m-panel-subtitle">Yandex 原生</div>
                            <div class="flex mt5">
                                <el-input v-model="yandex_config.native_id" size="medium" @change="onChangeYandexConfig"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">Yandex 原生 2</div>
                            <div class="flex mt5">
                                <el-input v-model="yandex_config.native_id2" size="medium" @change="onChangeYandexConfig"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">Yandex 横幅</div>
                            <div class="flex mt5">
                                <el-input v-model="yandex_config.banner_id" size="medium" @change="onChangeYandexConfig"></el-input>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            <div class="m-panel mt20" v-if="channel != 'vivo' && channel != 'xm'">
                <div class="flex fs14 items-center" style="color: #636578; font-weight: 600">
                    <div class="flex-1 flex">广告2 ID</div>
                </div>
                <div class="mt20 flex">
                    <div class="flex-1">
                        <div class="items-center">
                            <div class="fs12 flex m-panel-subtitle">TopOn AppId</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_app_id" @change="onChangeTopOnId('topon_app_id', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn AppKey</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_appkey" @change="onChangeTopOnId('topon_appkey', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 开屏</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_splash" @change="onChangeTopOnId('topon_splash', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 横幅</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_banner" @change="onChangeTopOnId('topon_banner', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <!-- <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 横幅 2</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_banner_2" @change="onChangeTopOnId('topon_banner_2', $event)" size="medium"></el-input>
                            </div>
                        </div> -->
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 插屏1</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_inter_id" @change="onChangeTopOnId('topon_inter_id', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 插屏2 / 大原生</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_inter_id2" @change="onChangeTopOnId('topon_inter_id2', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 插屏3 / 大原生</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_inter_id3" @change="onChangeTopOnId('topon_inter_id3', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        
                    </div>
                    <div class="flex-1 ml20">
                        <div class="items-center">
                            <div class="fs12 flex m-panel-subtitle">TopOn 激励1</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_reward_id" @change="onChangeTopOnId('topon_reward_id', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 激励2</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_reward_id2" @change="onChangeTopOnId('topon_reward_id2', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 原生 1</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_native_id" @change="onChangeTopOnId('topon_native_id', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 原生 2</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_native_id1" @change="onChangeTopOnId('topon_native_id1', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 原生 3</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_native_id2" @change="onChangeTopOnId('topon_native_id2', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 原生 4</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_native_id3" @change="onChangeTopOnId('topon_native_id3', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn 原生横幅</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_banner_native_id" @change="onChangeTopOnId('topon_banner_native_id', $event)" size="medium"></el-input>
                            </div>
                        </div>
        
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn MTG ID</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_mtg_id" @change="onChangeTopOnId('mtg_id', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn MTG KEY</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_mtg_key" @change="onChangeTopOnId('mtg_key', $event)" size="medium"></el-input>
                            </div>
                        </div>
                        <div class="items-center mt15">
                            <div class="fs12 flex m-panel-subtitle">TopOn Debug KEY</div>
                            <div class="flex mt5">
                                <el-input v-model="default_version_config.topon_debug_key" @change="onChangeTopOnId('topon_debug_key', $event)" size="medium"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <el-drawer
            size="35%"
            :visible.sync="changeLogVisible"
            :with-header="false">
            <div class="pd15">
                <div v-for="(item, i) in configs" :key="i" class="mb10 fs12 pd10 br5" style="box-shadow: 0 0 5px rgba(0,0,0,0.1);">
                <div class="fs12 flex">{{ item.create_time }}</div>
                <div class="flex items-center">
                    <div>
                    俄罗斯开关: {{ item.config.on ? '开' : '关' }}
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    非俄罗斯开关: {{ item.config.on ? '开' : '关' }}
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    UI弹开关: {{ item.config.interval_click_mode ? '开' : '关' }}
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    广告轮询模式: {{ item.config.interval_ad_mode == 1 ? '开' : '关' }}
                    </div>
                </div>
                <div class="flex items-center">
                    <div>
                    不间断加载: {{ item.config.ads_load_uninterrupted ? '开' : '关' }}
                    </div>
                </div>
                <div class="flex" v-if="item.interval_click_mode">
                    <div>
                    原生: {{ item.config.interval/1000 }} s
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    插屏: {{ item.config.interval2/1000 }} s
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    激励: {{ item.config.interval3/1000 }} s
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    横幅: {{ item.config.interval4/1000 }} s
                    </div>
                </div>
                <div class="flex" v-else>
                    <div>
                    轮询间隔: {{ item.config.interval5/1000 }} s
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    轮询广告: {{ item.config.interval_ad_sequence_name }}
                    </div>
                    
                </div>
                <div class="flex">
                    <div>
                    GP测试模式: {{ item.config.test_mode ? '开' : '关' }}
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    横幅位置: {{ item.config.banner_pos_name }}
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    插屏后激励: {{ item.config.inter_after_reward ? '开' : '关' }}
                    </div>
                </div>
                <div class="flex">
                    <div>
                    华为原生间隔: {{ item.config.interval / 1000 }}
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    华为插屏间隔: {{ item.config.interval2 / 1000 }}
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div>
                    华为激励间隔: {{ item.config.interval3 / 1000 }}
                    </div>
                </div>

                <div class="flex">
                    <div v-if="item.config.interval6">
                    华为/传音 强弹插屏: {{ item.config.interval6 / 1000 }}
                    </div>
                    <el-divider v-if="item.config.interval6" direction="vertical"></el-divider>
                    <div v-if="item.config.interval7">
                    华为/传音 强弹激励: {{ item.config.interval7 / 1000 }}
                    </div>
                </div>
                <div class="flex">
                    <div v-if="item.username">
                    操作人: {{ item.username }}
                    </div>
                    
                </div>
                
                </div>
            </div>
        </el-drawer>


        <el-dialog
            title="添加广告源ID"
            :visible.sync="srcVisible"
            width="30%">
            <div>
                <div class="flex items-center">
                    <div style="width: 120px;">户ID</div>
                    <el-input v-model="srcForm.adv_id" placeholder="户ID"></el-input>
                </div>
                <div class="flex items-center mt10">
                    <div style="width: 120px;">广告源ID</div>
                    <el-input v-model="srcForm.src_id" placeholder="广告源ID"></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="srcVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveSrcId">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            loadingApps: false,
            apps: [],
            curApp: null,
            appBoxVisiable: false,
            appBoxVisiable2: false,
            searchText: "",
            versions: [],
            selectVersion: null,
            currentVersionConfig: {
                interval_ad_mode_switch: false,
                float_native_click_rate: 0,
                native_click_rate: 0
            },
            default_version_config: {
                banner: null,
                splash: null,
                native: null,
                interstitial: null,
                interstitial_2: null,
                reward_0: null,
                reward_1: null
            },
            isNotLogin: false,
            bannerPositions: [
                { value: 0, label: "左上" },
                { value: 1, label: "上" },
                { value: 2, label: "右上" },
                { value: 3, label: "左下" },
                { value: 4, label: "下" },
                { value: 5, label: "右下" },
            ],

            changeLogVisible: false,
            configs: [],
            sdkMode: -1,
            group_0: "group_color_0",
            group_1: "group_color_1",
            group_2: "group_color_0",
            group_3: "group_color_1",
            group_4: "group_color_1",

            group_switch_0: false,
            group_switch_1: false,

            nativeErr: "",
            nativeLayout: {
                layout: null,
                margin0: null,
                margin1: null,
                margin2: null,
                margin3: null
            },
            nativePositions: [
                { value: -1, label: "无" },
                { value: 1, label: "左上" },
                { value: 2, label: "右上" },
                { value: 3, label: "左下" },
                { value: 4, label: "右下" },
            ],
            saveLoading: false,
            channel: "",

            srcIdData: [],
            srcVisible: false,
            srcForm: {
                src_id: null,
                adv_id: null,
                package_name: null
            },


            miAdUnits: [],
            dialogAdIdVisible: false,
            adUnitTypes: [
                { value: 0, label: "原生" },
                { value: 1, label: "插屏" },
                { value: 2, label: "激励" },
                { value: 3, label: "开屏" },
                { value: 4, label: "横幅" },
                { value: 5, label: "横幅原生" },
            ],
            adUnitForm: {
                adId: null,
                price: 0,
                type: 0
            },
            yandex_config: {
                appopen_id: null,
                reward_id: null,
                inter_id: null,
                native_id: null,
                banner_id: null
            },
        }
    },
    created() {
		this.channel = window.channel;
        this.getAppInfo();
        this.checkLogin();
        this.handler = setInterval(() => {
            this.checkLogin();
        }, 3600000);
    },
    methods: {
        async remoteMethod(query) {
            this.searchText = query;
            if (this.searchHandler && this.searchHandler != -1) {
                clearTimeout(this.searchHandler)
            }
            this.searchHandler = setTimeout(() => {
                this.searchHandler = -1;
                this.onSearch();
            }, 1000);
            // setTimeout(() => {
            //     this.loadingApps = false;
            //     this.options = this.list.filter(item => {
            //     return item.label.toLowerCase()
            //         .indexOf(query.toLowerCase()) > -1;
            //     });
            // }, 200);
            // } else {
            //     this.options = [];
            // }
        },
        async checkLogin() {
            let rs = await this.$api.checkLogin();
            if (rs.err == 1) {
                this.isNotLogin = true;
                this.$router.push('/login')
            }
        },
        async getAppInfo() {
            let spn = window.localStorage.getItem("spn");
            if (spn != null && spn != "" && spn != undefined && spn != "undefined") {
                let rs = await this.$api.queryAppInfo(spn);
                if (rs.err == 0 && rs.data.length > 0) {
                    this.apps = rs.data
                    this.selectApp(rs.data[0])
                } else {
                    this.getApps();
                }
            } else {
                this.getApps();
            }
        },
        async getApps() {
            let rs = await this.$api.apps(0, 20);
            if (rs.err == 0) {
                for (let item of rs.data) {
                if (item.icon != null) {
                    item.icon = item.icon.replace("https://apicn.311419.cn", this.$api.request_storage.url);
                } else {
                    item.icon = require("../../assets/logo_android.png");
                }
                }
                this.apps = rs.data;
                // this.curApp = rs.data[0];
                this.selectApp(rs.data[0])
                // this.getAppVersions(this.curApp.id)
            }
        },
        async onSearch() {
            if (this.searchText != "") {
                this.versions.splice(0)
                this.loadingApps = true;
                this.apps.splice(0);
                let rs = await this.$api.queryApp(this.searchText);
                this.loadingApps = false;
                if (rs.err == 0) {
                    for (let item of rs.data) {
                        if (item.icon != null) {
                            item.icon = item.icon.replace("https://apicn.311419.cn", this.$api.request_storage.url);
                        } else {
                            item.icon = require("../../assets/logo_android.png");
                        }
                    }
                    this.apps = rs.data;
                } else {
                    // setTimeout(() => {
                    //     this.onSearch();
                    // }, 1000);
                }
            }
        },
        selectApp(app) {
            this.apps = [app]
            window.localStorage.setItem("spn", app.package_name);
            this.curApp = app;
            this.selectVersion = null
            this.currentVersionConfig = {};
            this.yandex_config = {
                appopen_id: null,
                reward_id: null,
                inter_id: null,
                native_id: null,
                banner_id: null
            }
            this.getAppVersions(app.id);
            this.getSrcIds(app.package_name)
        },
        async getSrcIds(package_name) {
            let rs = await this.$api.getSrcIds(package_name);
            if (rs.err == 0) {
                this.srcIdData = rs.data;
            }
        },
        showAddSrcId() {
            this.srcVisible = true;
            this.srcForm.package_name = this.curApp.package_name;
            this.srcForm.adv_id = null;
            this.srcForm.src_id = null;
        },
        async saveSrcId() {
            let rs = await this.$api.saveSrcId(this.srcForm.package_name, this.srcForm.adv_id, this.srcForm.src_id);
            if (rs.err == 0) {
                this.getSrcIds(this.curApp.package_name);
                this.srcVisible = false;
            }
        },
        onChangeYandexConfig() {
            let config = JSON.stringify(this.yandex_config);
            this.onChangeAdid("yandex_config", config);
        },
        onChangeAppVersion(version) {
            console.log("onChangeAppVersion")

            let vo = this.versions.find((it) => {
                return it.version_code == version;
            })

            if (!vo.is_set) {
                for (let key in vo) {
                if (key == "app_id" || key == "version_name") {
                    continue;
                }
                let v = this.default_version_config[key];
                if (v != null) {
                    vo[key] = v;
                }
                }
                vo.ad_sequence = this.default_version_config.ad_sequence;
                vo.interval_ad_sequence = this.default_version_config.interval_ad_sequence;
                vo.interval_ad_sequences = this.default_version_config.interval_ad_sequences;
                vo.interval_free_ad_sequences = this.default_version_config.interval_free_ad_sequences;
            }

            this.group_switch_0 = vo.interval1_sec != 0 || vo.interval2_sec != 0 || vo.interval3_sec != 0
            this.group_switch_1 = vo.interval6_sec != 0 || vo.interval7_sec != 0

            // try {
            //     let nativeLayout = JSON.parse(vo.float_native_layout);
            //     let ms = nativeLayout.margin.split(",");
            //     let m0 = parseInt(ms[0]);
            //     let m1 = parseInt(ms[1]);
            //     let m2 = parseInt(ms[2]);
            //     let m3 = parseInt(ms[3]);

            //     this.nativeLayout = {
            //         layout: nativeLayout.layout,
            //         margin0: m0,
            //         margin1: m1,
            //         margin2: m2,
            //         margin3: m3,
            //         o0: nativeLayout.o0 || false,
            //         o1: nativeLayout.o1 || false,
            //         o2: nativeLayout.o2 || false,
            //         o3: nativeLayout.o3 || false,
            //         a0: nativeLayout.a0 || false,
            //         a1: nativeLayout.a1 || false,
            //         a2: nativeLayout.a2 || false,
            //         a3: nativeLayout.a3 || false,
            //         p0: nativeLayout.p0 || 0,
            //         p1: nativeLayout.p1 || 0,
            //         p2: nativeLayout.p2 || 0,
            //         p3: nativeLayout.p3 || 0
            //     }

            // } catch {
            //     this.nativeLayout = {
            //         layout: null,
            //         margin0: null,
            //         margin1: null,
            //         margin2: null,
            //         margin3: null,
            //         o0: false,
            //         o1: false,
            //         o2: false,
            //         o3: false,
            //         a0: false,
            //         a1: false,
            //         a2: false,
            //         a3: false,
            //         p0: 0,
            //         p1: 0,
            //         p2: 0,
            //         p3: 0
            //     }
            // }


            

            this.currentVersionConfig = vo;
            this.onChangeMode();
        },
        async getAppVersions(id) {
            await this.getDefaultConfig(id);
            let rs = await this.$api.getAppVersions(id);
            if (rs.err == 0) {
                for (let vo of rs.data) {
                    if (vo.on == 1) {
                        vo.on = true
                    }
                    vo.interval1_sec = vo.interval / 1000
                    vo.interval2_sec = vo.interval2 / 1000
                    vo.interval3_sec = vo.interval3 / 1000
                    vo.interval4_sec = vo.interval_banner / 1000
                    vo.interval5_sec = vo.interval5 / 1000
                    vo.interval6_sec = vo.interval6 / 1000
                    vo.interval7_sec = vo.interval7 / 1000
                    vo.interval8_sec = vo.interval8 / 1000
                    vo.interval9_sec = vo.interval9 / 1000
                    vo.ad_min_sec = vo.ad_min_interval / 1000
                    vo.ad_delay_sec = vo.ad_delay_time / 1000;
                    vo.silent_sec = vo.silent_time / 1000;
                    vo.float_native_clost_sec = vo.float_native_clost_time / 1000;
                    vo.interval_ad_mode_switch = vo.interval_ad_mode == 1;
                    if (vo.interval_ad_sequence != null) {
                        vo.interval_ad_sequences = [];
                        vo.interval_free_ad_sequences = [];
                        let seqs = vo.interval_ad_sequence.split(",");
                        for (let seq of seqs) {
                            let tag = parseInt(seq);
                            let adName = "插屏"
                            switch (tag) {
                                case 0: adName = "原生"; break;
                                case 1: adName = "插屏"; break;
                                case 2: adName = "激励"; break;
                                default: adName = "插屏"; break;
                            }
                            
                            vo.interval_ad_sequences.push({
                                tag,
                                name: adName
                            })
                        }

                        if (vo.interval_free_ad_sequence) {
                            seqs = vo.interval_free_ad_sequence.split(",");
                            for (let seq of seqs) {
                                let tag = parseInt(seq);
                                let adName = "插屏"
                                switch (tag) {
                                    case 0: adName = "原生"; break;
                                    case 1: adName = "插屏"; break;
                                    case 2: adName = "激励"; break;
                                    default: adName = "插屏"; break;
                                }
                                
                                vo.interval_free_ad_sequences.push({
                                    tag,
                                    name: adName
                                })
                            }
                        } else {
                            vo.interval_free_ad_sequences = [];
                        }
                    } else {
                        vo.interval_ad_sequences = [];
                        vo.interval_free_ad_sequences = [];
                    }
                    
                    
                    
                }
                this.versions = rs.data.reverse();
                if (rs.data.length > 0) {
                    this.selectVersion = rs.data[0].version_code;
                    this.onChangeAppVersion(rs.data[0].version_code)
                }
            } else {
                // setTimeout(() => {
                //     this.getAppVersions(id)
                // }, 1000);
            }
        },
        async getDefaultConfig(id) {
            let rs = await this.$api.getAppById(id);
            if (rs.err == 0) {
                let vo = rs.data;
                if (vo.interval_ad_sequence != null) {
                    vo.interval_ad_sequences = [];
                    vo.interval_free_ad_sequences = [];
                    let seqs = vo.interval_ad_sequence.split(",");
                    for (let seq of seqs) {
                        let tag = parseInt(seq);
                        let adName = "插屏"
                        switch (tag) {
                            case 0: adName = "原生"; break;
                            case 1: adName = "插屏"; break;
                            case 2: adName = "激励"; break;
                            default: adName = "插屏"; break;
                        }
                        
                        vo.interval_ad_sequences.push({
                            tag,
                            name: adName
                        })
                    }

                    if (vo.interval_free_ad_sequence) {
                        seqs = vo.interval_free_ad_sequence.split(",");
                        for (let seq of seqs) {
                            let tag = parseInt(seq);
                            let adName = "插屏"
                            switch (tag) {
                                case 0: adName = "原生"; break;
                                case 1: adName = "插屏"; break;
                                case 2: adName = "激励"; break;
                                default: adName = "插屏"; break;
                            }
                            
                            vo.interval_free_ad_sequences.push({
                                tag,
                                name: adName
                            })
                        }
                    } else {
                        vo.interval_free_ad_sequences = [];
                    }
                } else {
                    vo.interval_ad_sequences = [];
                    vo.interval_free_ad_sequences = [];
                }
                this.default_version_config = rs.data;
                try {
                    this.miAdUnits = JSON.parse(vo.mi_ad_ids);
                    for (let item of this.miAdUnits) {
                        item.type_name = this.adUnitTypes.find((it) => {
                            return it.value == item.type;
                        }).label
                    }
                    this.miAdUnits.sort((a, b) => {
                        if (a.type != b.type) {
                            return a.type - b.type;
                        } else {
                            return a.price - b.price;
                        }
                    })
                } catch {
                    this.miAdUnits = [];
                }
                if (this.channel == "xm") {
                    try {
                        if (vo.yandex_config != null && vo.yandex_config != "") {
                            this.yandex_config = JSON.parse(vo.yandex_config);
                        }
                    } catch {
                        this.yandex_config = {
                            appopen_id: null,
                            reward_id: null,
                            inter_id: null,
                            native_id: null,
                            banner_id: null
                        }
                    }
                }


                let m0 = 0, m1 = 0, m2 = 0, m3 = 0, m20 = 0, m21 = 0, m22 = 0, m23 = 0, m30 = 0, m31 = 0, m32 = 0, m33 = 0, m40 = 0, m41 = 0, m42 = 0, m43 = 0;
                if (vo.float_native_layout != null) {
                    let nativeLayout = JSON.parse(vo.float_native_layout);
                    console.log(nativeLayout)
                    if (nativeLayout.margin != null) {
                        let ms = nativeLayout.margin.split(",");
                        m0 = parseInt(ms[0]);
                        m1 = parseInt(ms[1]);
                        m2 = parseInt(ms[2]);
                        m3 = parseInt(ms[3]);
                    }
                    
                    if (nativeLayout.margin2 != null) {
                        let ms = nativeLayout.margin2.split(",");
                        m20 = parseInt(ms[0]);
                        m21 = parseInt(ms[1]);
                        m22 = parseInt(ms[2]);
                        m23 = parseInt(ms[3]);
                    }
        
                    if (nativeLayout.margin3 != null) {
                        let ms = nativeLayout.margin3.split(",");
                        m30 = parseInt(ms[0]);
                        m31 = parseInt(ms[1]);
                        m32 = parseInt(ms[2]);
                        m33 = parseInt(ms[3]);
                    }
        
                    if (nativeLayout.margin4 != null) {
                        let ms = nativeLayout.margin4.split(",");
                        m40 = parseInt(ms[0]);
                        m41 = parseInt(ms[1]);
                        m42 = parseInt(ms[2]);
                        m43 = parseInt(ms[3]);
                    }
        
                    this.nativeLayout = {
                        layout: nativeLayout.layout,
                        margin0: m0,
                        margin1: m1,
                        margin2: m2,
                        margin3: m3,
        
                        layout2: nativeLayout.layout2,
                        margin20: m20,
                        margin21: m21,
                        margin22: m22,
                        margin23: m23,
        
                        layout3: nativeLayout.layout3,
                        margin30: m30,
                        margin31: m31,
                        margin32: m32,
                        margin33: m33,
        
                        layout4: nativeLayout.layout4,
                        margin40: m40,
                        margin41: m41,
                        margin42: m42,
                        margin43: m43
                    }

                }

            }
        },
        selectAd(tag) {
            let adName = "插屏"
            switch (tag) {
                case 0: adName = "原生"; break;
                case 1: adName = "插屏"; break;
                case 2: adName = "激励"; break;
                default: adName = "插屏"; break;
            }
            this.currentVersionConfig.interval_ad_sequences.push({
                tag,
                name: adName
            })
        },
        removeAdSeq(tag) {
            let i = this.currentVersionConfig.interval_ad_sequences.indexOf(tag);
            if (i != -1) {
                this.currentVersionConfig.interval_ad_sequences.splice(i, 1);
            }
        },
        selectAd2(tag) {
            let adName = "插屏"
            switch (tag) {
                case 0: adName = "原生"; break;
                case 1: adName = "插屏"; break;
                case 2: adName = "激励"; break;
                default: adName = "插屏"; break;
            }
            this.currentVersionConfig.interval_free_ad_sequences.push({
                tag,
                name: adName
            })
        },
        removeAdSeq2(tag) {
            let i = this.currentVersionConfig.interval_free_ad_sequences.indexOf(tag);
            if (i != -1) {
                this.currentVersionConfig.interval_free_ad_sequences.splice(i, 1);
            }
        },
        async save() {
            let float_native_layout = null;
            if ( this.channel == "vivo" || (
                this.nativeLayout.layout != null && this.nativeLayout.margin0 != null && this.nativeLayout.margin1 != null && this.nativeLayout.margin2 != null && this.nativeLayout.margin3 != null
                )
            ) {
                float_native_layout = JSON.stringify({
                    layout: this.nativeLayout.layout,
                    margin: `${this.nativeLayout.margin0},${this.nativeLayout.margin1},${this.nativeLayout.margin2},${this.nativeLayout.margin3}`,
                    layout2: this.nativeLayout.layout2,
                    margin2: `${this.nativeLayout.margin20},${this.nativeLayout.margin21},${this.nativeLayout.margin22},${this.nativeLayout.margin23}`,
                    layout3: this.nativeLayout.layout3,
                    margin3: `${this.nativeLayout.margin30},${this.nativeLayout.margin31},${this.nativeLayout.margin32},${this.nativeLayout.margin33}`,
                    layout4: this.nativeLayout.layout4,
                    margin4: `${this.nativeLayout.margin40},${this.nativeLayout.margin41},${this.nativeLayout.margin42},${this.nativeLayout.margin43}`,
                });
            }
            console.log(float_native_layout)

            this.currentVersionConfig.float_native_layout = float_native_layout;
            let interval_ad_sequence = this.currentVersionConfig.interval_ad_sequences.map((it) => {return it.tag}).join(",")
            let interval_free_ad_sequence = this.currentVersionConfig.interval_free_ad_sequences.map((it) => {return it.tag}).join(",")
            let params = {
                app_id: this.currentVersionConfig.app_id,
                interval: this.currentVersionConfig.interval1_sec * 1000,
                interval2: this.currentVersionConfig.interval2_sec * 1000,
                interval3: this.currentVersionConfig.interval3_sec * 1000,
                interval4: this.currentVersionConfig.interval4_sec * 1000,
                interval5: this.currentVersionConfig.interval5_sec * 1000,
                interval6: this.currentVersionConfig.interval6_sec * 1000,
                interval7: this.currentVersionConfig.interval7_sec * 1000,
                interval8: this.currentVersionConfig.interval8_sec * 1000,
                interval9: this.currentVersionConfig.interval9_sec * 1000,
                ad_min_interval: this.currentVersionConfig.ad_min_sec * 1000,
                ad_min_interval_offset: this.currentVersionConfig.ad_min_interval_offset,
                interval_ad_mode: this.currentVersionConfig.interval_ad_mode_switch ? 1 : 0,
                interval_ad_sequence,
                interval_free_ad_sequence,
                interval_click_mode: this.currentVersionConfig.interval_click_mode,
                on: this.currentVersionConfig.on,
                non_ru_on: this.currentVersionConfig.non_ru_on,
                ads_load_uninterrupted: this.currentVersionConfig.ads_load_uninterrupted,
                version_code: this.currentVersionConfig.version_code,
                test_mode: this.currentVersionConfig.test_mode,
                app_switch_1: this.currentVersionConfig.app_switch_1,
                app_switch_2: this.currentVersionConfig.app_switch_2,
                banner_pos: this.default_version_config.banner_pos,
                float_native_count: this.currentVersionConfig.float_native_count,
                float_native_width: this.currentVersionConfig.float_native_width,
                float_native_layout,
                float_native_click_rate: this.currentVersionConfig.float_native_click_rate,
                inter_after_reward: this.currentVersionConfig.inter_after_reward,
                native_click_rate: this.currentVersionConfig.native_click_rate,
                float_native_clost_time: this.currentVersionConfig.float_native_clost_sec * 1000,
                ad_delay_time: this.currentVersionConfig.ad_delay_sec * 1000,
                silent_time: this.currentVersionConfig.silent_sec * 1000,
                reward_request_times: this.currentVersionConfig.reward_request_count,
                tick_after_close: this.currentVersionConfig.tick_after_close,
                game_url_1: this.currentVersionConfig.game_url_1,
                game_url_2: this.currentVersionConfig.game_url_2,
                native_load_interval: this.currentVersionConfig.native_load_interval,
                inter_load_interval: this.currentVersionConfig.inter_load_interval,
                banner_mode: this.currentVersionConfig.banner_mode,
                inter_mode: this.currentVersionConfig.inter_mode,
                native_banner_width: this.default_version_config.native_banner_width,
                native_banner_height: this.default_version_config.native_banner_height,
                dialog_mode_native: this.default_version_config.dialog_mode_native,
                banner_click_rate: this.currentVersionConfig.banner_click_rate,
                other_native_click_rate: this.currentVersionConfig.other_native_click_rate,
                mtg_native_click_rate: this.currentVersionConfig.mtg_native_click_rate,
                inter_mode: this.currentVersionConfig.inter_mode,
                inter_mode_non_ru: this.currentVersionConfig.inter_mode_non_ru,
            }
            this.saveLoading = true;
            let rs = await this.$api.saveAppVersionConfig(params);
            this.saveLoading = false;
            if (rs.err== 0) {
                    this.currentVersionConfig.is_set = true;
                    this.$message({
                    type: "success",
                    message: "修改成功"
                })
            }
        },
        verifyNativeLayout() {
            if (this.currentVersionConfig.float_native_layout == "" || this.currentVersionConfig.float_native_layout == null) {
                this.nativeErr = "";
                return;
            }
            console.log(this.currentVersionConfig.float_native_layout)
            try {
                let vo = JSON.parse(this.currentVersionConfig.float_native_layout)
                if (vo.layout == null) {
                this.nativeErr = "缺少layout"
                return;
                }
                if (vo.layout <= 0 || vo.layout > 4) {
                this.nativeErr = "layout值只能为1(左上),2(右上),3(左下),4(右下)"
                return;
                }
                if (vo.margin == null) {
                this.nativeErr = "缺少margin(边距)"
                return;
                }
                let ms = vo.margin.split(",");
                if (ms.length != 4) {
                this.nativeErr = "margin格式不对, "
                return;
                }
                this.nativeErr = "";
            } catch {
                this.nativeErr = "格式错误"
            }
        },
        navToLogin() {
            this.$router.push('/login')
        },
        async onChangeAdid(key, value) {
            let rs = await this.$api.updateAdId(this.default_version_config.package_name, key, value);
            if (rs.err == 0) {
                this.$message({
                type: "success",
                message: "修改成功"
                })
            }
        },
        async onChangeTopOnId(key, value) {
            let rs = await this.$api.updateTopOnId(this.default_version_config.package_name, key, value);
            if (rs.err == 0) {
                this.$message({
                    type: "success",
                    message: "修改成功"
                })
            }
        },
        async showModifyHistory() {
            let app_id = this.curApp.id;
            // console.log(this.currentVersionConfig.version_code)
            this.changeLogVisible = true;

            let rs = await this.$api.getAppVersionChangeLogs(app_id, this.currentVersionConfig.version_code);
            if (rs.err == 0) {
                for (let item of rs.data) {
                item.config = JSON.parse(item.config);
                let pos = this.bannerPositions.find((it) => {
                    return it.value == item.config.banner_pos
                })
                if (pos != null) {
                    item.config.banner_pos_name = pos.label
                } else {
                    item.config.banner_pos_name = "上"
                }
                if (item.config.interval_ad_sequence != "NaN") {
                    let names = item.config.interval_ad_sequence.split(",").map((tag) => {
                    let adName = ""
                    switch (tag) {
                        case 0: adName = "原生"; break;
                        case 1: adName = "插屏"; break;
                        case 2: adName = "激励"; break;
                        default: adName = "插屏"; break;
                    }
                    return adName;
                    })
                    item.config.interval_ad_sequence_name = names.join(",");
                } else {
                    item.config.interval_ad_sequence_name = "无"
                }
                }
                this.configs = rs.data;
            }
        },
        copyClickUrl() {
            let url = `https://quick.91mgame.com/open/vivo?package_name=${this.curApp.package_name}&os=__OS__&imei=__IMEI__&ip=__IP__&oaid=__OAID__&UA=__UA__&advertiserid=__ADVERTISERID__&requestid=__REQUESTID__&creativeid=__CREATIVEID__`
            navigator.clipboard.writeText(url).then(() => {
                this.$message({
                    type: "success",
                    message: "复制成功"
                })
            }).catch(err => {
            });
        },
        onChangeMode() {
            if (!this.currentVersionConfig.interval_click_mode && !this.currentVersionConfig.interval_ad_mode_switch) {
                this.sdkMode = 1;
                this.group_0 = "group_color_0";
                this.group_2 = "group_color_0";
                this.group_3 = "group_color_1";
            } else if (this.currentVersionConfig.interval_click_mode && !this.currentVersionConfig.interval_ad_mode_switch) {
                this.sdkMode = 2;
                this.group_0 = "group_color_0";
                this.group_1 = "group_color_1";
                this.group_2 = "group_color_1";
                this.group_3 = "group_color_0";
            } else if (this.currentVersionConfig.interval_click_mode && this.currentVersionConfig.interval_ad_mode_switch) {
                this.sdkMode = 3;
                this.group_0 = "group_color_1";
                this.group_3 = "group_color_1";
                this.group_4 = "group_color_0";
                this.group_2 = "group_color_0";
                this.group_1 = "group_color_0";

            } else if (!this.currentVersionConfig.interval_click_mode && this.currentVersionConfig.interval_ad_mode_switch) {
                this.sdkMode = 4;
                this.group_0 = "group_color_1";
                this.group_3 = "group_color_1";
                this.group_4 = "group_color_0";
                this.group_2 = "group_color_0";
            }
        },
        onChangeGroupSwitch0() {
            if (!this.group_switch_0) {
                this.currentVersionConfig.interval1_sec = 0;
                this.currentVersionConfig.interval2_sec = 0;
                this.currentVersionConfig.interval3_sec = 0;
            }
        },
        onChangeGroupSwitch1() {
            if (!this.group_switch_1) {
                this.currentVersionConfig.interval6_sec = 0;
                this.currentVersionConfig.interval7_sec = 0;
            }
        },
        async showModifyHistory() {
            let app_id = this.curApp.id;
            // console.log(this.currentVersionConfig.version_code)
            this.changeLogVisible = true;

            let rs = await this.$api.getAppVersionChangeLogs(app_id, this.currentVersionConfig.version_code);
            if (rs.err == 0) {
                for (let item of rs.data) {
                item.config = JSON.parse(item.config);
                let pos = this.bannerPositions.find((it) => {
                    return it.value == item.config.banner_pos
                })
                if (pos != null) {
                    item.config.banner_pos_name = pos.label
                } else {
                    item.config.banner_pos_name = "上"
                }
                if (item.config.interval_ad_sequence != "NaN") {
                    let names = item.config.interval_ad_sequence.split(",").map((tag) => {
                    let adName = ""
                    switch (tag) {
                        case 0: adName = "原生"; break;
                        case 1: adName = "插屏"; break;
                        case 2: adName = "激励"; break;
                        default: adName = "插屏"; break;
                    }
                    return adName;
                    })
                    item.config.interval_ad_sequence_name = names.join(",");
                } else {
                    item.config.interval_ad_sequence_name = "无"
                }
                }
                this.configs = rs.data;
            }
        },

        addAdUnit() {
            this.dialogAdIdVisible = true;
            this.adUnitForm = {
                adId: null,
                price: 0,
                type: 0
            }
        },
        saveAdUnit() {
            this.dialogAdIdVisible = false;
            let type_name = this.adUnitTypes.find((it) => {
                return it.value == this.adUnitForm.type
            }).label
            if (this.adUnitForm.adId == null || this.adUnitForm.adId == "") {
                this.$message({
                    type: "error",
                    message: "广告ID不能为空"
                })
                return;
            }
            if (this.adUnitForm.price == null || this.adUnitForm.price == "") {
                this.$message({
                    type: "error",
                    message: "价格不能为空"
                })
                return;
            }
            if (this.adUnitForm.price <= 0) {
                this.$message({
                    type: "error",
                    message: "价格不能小于0"
                })
                return;
            }
            if (this.adUnitForm.id == null) {
                this.miAdUnits.push({
                    id: this.miAdUnits.length + 1,
                    adId: this.adUnitForm.adId,
                    price: this.adUnitForm.price,
                    type: this.adUnitForm.type,
                    type_name
                })
            } else {
                let i = this.miAdUnits.findIndex((it) => {
                    return it.id == this.adUnitForm.id;
                })
                if (i != -1) {
                    this.miAdUnits[i].adId = this.adUnitForm.adId;
                    this.miAdUnits[i].price = this.adUnitForm.price;
                    this.miAdUnits[i].type = this.adUnitForm.type;
                    this.miAdUnits[i].type_name = type_name;
                }
            }

            this.saveAdUnits();
            
        },
        editAdUnit(item) {
            this.adUnitForm = {
                id: item.id,
                adId: item.adId,
                price: item.price,
                type: item.type
            }
            this.dialogAdIdVisible = true;
        },
        deleteAdUnit(item) {
            let i = this.miAdUnits.indexOf(item);
            if (i != -1) {
                this.miAdUnits.splice(i, 1);
            }
            this.saveAdUnits();
        },
        saveAdUnits() {
            this.miAdUnits.sort((a, b) => {
                if (a.type != b.type) {
                    return a.type - b.type;
                } else {
                    return a.price - b.price;
                }
            })
            let adIds = this.miAdUnits.map((it) => {
                return {
                    adId: it.adId,
                    price: it.price,
                    type: it.type
                }
            })
            this.onChangeAdid("mi_ad_ids", JSON.stringify(adIds));
            
            
        },
    }
}
</script>


<style lang="less" scoped>
.m-version-item {
    height: 45px;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
        background-color: #eee;
    }

    &.m-is-select {
        background-color: #676cf6;
        color: white!important;
    }

    .m-select-version {
        
    }
}

.m-panel-subtitle {
    color: #828392;
}

</style>


<style>
.m-api-item {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-left: 20px;
    /* border-bottom: 1px solid #e6e6e6; */
}
.m-api-item.is-active {
    background-color: #eaeaed;
}
.m-api-item:hover {
    background-color: #eaeaed;
}

/* .my-dialog {
    border-radius: 10px;
}
.my-dialog>.el-dialog__header {
    padding: 0;
}
.my-dialog>.el-dialog__body {
    padding-top: 10px!important;
    padding-bottom: 10px!important;
} */

.m-GET {
    color: #89da9f;
}

.m-var-tag {
    display: flex;
    align-items: center;
    border-radius: 5px;
    border: 1px solid #ddebfd;
    background-color: #eef5fe;
    padding-left: 10px;
    padding-right: 10px;
}
.m-var-tag>.type {
    font-size: 9px;
    font-weight: bold;
    text-transform: uppercase;
    margin-left: 5px;
    margin-top: 2px;
    color: #89da9f;
}
.m-var-tag>.name {
    color: #5a9cf8;
    font-size: 12px;
}

.jsoneditor-menu {
    display: none;
}

.jsoneditor {
    border: none!important;
}

.m-history-panel {
    width: 0px;
    transition: 0.5s width ease;
}

.m-history-panel.expand {
    width: 240px;
    transition: 0.5s width ease;
    /* border-left: 1px solid rgba(0,0,0.05); */
}
</style>


